import React from 'react';
import { Link, useParams, Navigate } from 'react-router-dom';
import innovativePackagingData from '../../../data/innovativePackagingData';
import SEO from '../../../components/SEO';
import '../ProductDetail.css';

const InnovativePackagingCategory = () => {
  const { category } = useParams();
  const categoryData = innovativePackagingData[category];

  if (!categoryData) {
    return <Navigate to="/products/innovative-protective-packaging" replace />;
  }

  return (
    <div className="product-detail-page">
      <SEO
        title={categoryData.title}
        description={categoryData.subtitle}
        path={`/products/innovative-protective-packaging/${category}`}
      />
      {/* Hero Section */}
      <section className="product-detail-hero">
        <div className="product-detail-hero-overlay"></div>
        <div className="container">
          <h1 className="product-detail-hero-title">{categoryData.title}</h1>
        </div>
      </section>

      {/* Introduction */}
      <section className="product-intro-section">
        <div className="container">
          <div className="intro-content-full">
            <p className="intro-paragraph">{categoryData.intro}</p>
          </div>
        </div>
      </section>

      {/* Products */}
      <section className="box-types-section">
        <div className="container">
          <h2 className="section-title">Available Options</h2>
          <div className={`box-types-grid${categoryData.products.length === 2 ? ' two-column' : ''}`}>
            {categoryData.products.map((product) => (
              <div key={product.slug} className="box-type-card">
                <div className="box-type-image">
                  <img src={product.image} alt={product.name} />
                </div>
                <div className="box-type-content">
                  <h3 className="box-type-title">{product.name}</h3>
                  <p className="box-type-desc">{product.subtitle}</p>
                  <Link
                    to={`/products/innovative-protective-packaging/${category}/${product.slug}`}
                    className="box-type-link-btn"
                  >
                    Learn More
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Need Guidance */}
      <section className="why-applications-section">
        <div className="container">
          <div className="why-applications-grid single-column">
            <div className="applications-column">
              <h2 className="section-title">Need guidance?</h2>
              <p className="intro-paragraph">
                Let our team help you choose the right {categoryData.title.toLowerCase()} system for your product.
              </p>
              <Link to="/contact" className="btn-cta-primary">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default InnovativePackagingCategory;
